export default __webpack_public_path__ + "static/media/high-tensile-bolts.0f926259.webp";